module.exports = __webpack_public_path__ + "img/MES6Area_selection.7be38437.png";